import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { AbonnementModal } from '../components/AbonnementModal';
import logo from '../assets/logo_brandstarter.png';

const css = `
  .fe { min-height: 100vh; min-height: 100dvh; background: #F6F2EC; font-family: 'Inter', system-ui, sans-serif; color: #222; display: flex; justify-content: center; }
  .fe-w { width: 100%; max-width: 460px; padding: 22px 20px 32px; display: flex; flex-direction: column; }
  .fe-logo { height: 34px; width: auto; }
  .fe-hero { background: #173B34; color: #F6F2EC; border-radius: 24px; padding: 26px 22px; margin-top: 22px; }
  .fe-k { font-size: 11px; letter-spacing: .14em; text-transform: uppercase; font-weight: 700; opacity: .7; }
  .fe-t { font-size: 30px; font-weight: 800; line-height: 1.1; margin-top: 8px; letter-spacing: -0.01em; }
  .fe-p { font-size: 16px; line-height: 1.5; margin-top: 14px; opacity: .95; }
  .fe-card { background: #fff; border: 1px solid #E3DCCF; border-radius: 18px; padding: 16px 18px; margin-top: 14px; font-size: 15px; line-height: 1.5; }
  .fe-card b { color: #173B34; }
  .fe-btn { display: flex; align-items: center; justify-content: center; min-height: 54px; border: 0; border-radius: 14px; font-size: 16px; font-weight: 700; font-family: inherit; cursor: pointer; margin-top: 14px; width: 100%; }
  .fe-btn.o { background: #E4572E; color: #fff; }
  .fe-btn.g { background: #173B34; color: #F6F2EC; }
  .fe-btn.l { background: #fff; color: #173B34; border: 1.5px solid #E3DCCF; }
`;

export function FelicitationsPage() {
  const navigate = useNavigate();
  const [rep, setRep] = useState({});
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.getDashboard().then(d => {
      const by = {};
      (d.reponses || []).forEach(r => { by[Number(r.numeroModule)] = r.contenu || ''; });
      const get = (n, k) => ((by[n] || '').match(new RegExp(`^\\s*${k}:\\s*(.+)$`, 'm'))?.[1] || '').replace(/\*\*/g, '').trim();
      setRep({ brand: get(1, 'NOM_MARQUE'), promesse: get(4, 'POS_PROMESSE') });
    }).catch(() => {});
  }, []);
  return (
    <div className="fe">
      <style>{css}</style>
      <div className="fe-w">
        <img className="fe-logo" src={logo} alt="BrandStarter" />
        <div className="fe-hero">
          <div className="fe-k">Plateforme de marque</div>
          <div className="fe-t">{rep.brand ? `${rep.brand} est prête.` : 'Ta marque est prête.'}</div>
          {rep.promesse && <div className="fe-p">{rep.promesse}</div>}
        </div>
        <div className="fe-card"><b>5 briques complétées :</b> ton idée, ton client idéal, ta raison d'être, ton positionnement et ta voix. Tout est rassemblé dans Ma marque.</div>
        <button className="fe-btn o" onClick={() => navigate('/ma-marque')}>Voir ma marque</button>
        <div className="fe-card" style={{ marginTop: 22 }}><b>Et maintenant ?</b> Passe à l'action avec le parcours Lancer : ta fiche Google, ta première publicité et tes premiers clients.</div>
        <button className="fe-btn g" onClick={() => setOpen(true)}>Découvrir le parcours Lancer</button>
        <button className="fe-btn l" onClick={() => navigate('/parcours')}>Retour au parcours</button>
      </div>
      {open && <AbonnementModal onClose={() => setOpen(false)} />}
    </div>
  );
}
